<template>
  <div class="flex items-center h-full py-1 gap-2 overflow-hidden">
    <template v-if="types.length > 0">
      <span
        v-for="t in types"
        :key="t.label"
        :class="typeClass(t)"
        class="inline-flex items-center gap-1 px-1.5 py-0.5 text-[10px] font-medium rounded whitespace-nowrap"
      >
        <span>{{ t.label }}</span>
        <span class="opacity-80">{{ t.completed }}/{{ t.total }}</span>
      </span>
    </template>
    <span v-else class="text-xs text-gray-300">&mdash;</span>
  </div>
</template>

<script>
export default {
  name: 'Coding_OpportunityCell',
  props: ['params'],
  computed: {
    types() {
      const d = this.params.data;
      if (!d) return [];
      const out = [];
      if (d.suspect_total > 0) out.push({ label: 'Suspect', completed: d.suspect_completed, total: d.suspect_total });
      if (d.resub_total > 0) out.push({ label: 'Resub', completed: d.resub_completed, total: d.resub_total });
      if (d.early_start_total > 0) out.push({ label: 'Early Start', completed: d.early_start_completed, total: d.early_start_total });
      return out;
    },
  },
  methods: {
    typeClass(t) {
      if (t.completed === t.total) return 'bg-green-50 text-green-700';
      if (t.label === 'Suspect') return 'bg-[#EBF4FF] text-[#4C6E97]';
      if (t.label === 'Resub') return 'bg-[#FFF7F4] text-[#9F4D30]';
      return 'bg-gray-100 text-gray-600';
    },
  },
};
</script>
